import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { PageOutletLayoutProps } from '@t/c/layouts/pages/page-outlet.props';

import PageLayout from './page.component';

const PageOutletLayout: FC<PageOutletLayoutProps> = (props) => {
  return (
    <PageLayout {...props}>
      <Outlet />
    </PageLayout>
  );
};

export default PageOutletLayout;
